import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`These npm Paid Services Terms of Use (these `}<em parentName="p">{`npm Paid Services Terms`}</em>{`)
supplement the terms for npm Open Source offered by npm, Inc.
(`}<em parentName="p">{`npm`}</em>{`) at `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/policies/open-source-terms"
      }}>{`https://docs.npmjs.com/policies/open-source-terms`}</a>{` (`}<em parentName="p">{`npm Open
Source Terms`}</em>{`). They govern access to and use of `}<em parentName="p">{`npm Paid Services`}</em>{`,
including but not limited to the products known as  `}<em parentName="p">{`npm Solo`}</em>{` and
`}<em parentName="p">{`npm Orgs`}</em>{`, the private package storage, delivery,
organization management, and access control features of
`}<a parentName="p" {...{
        "href": "https://www.npmjs.com"
      }}>{`https://www.npmjs.com`}</a>{` (the `}<em parentName="p">{`Website`}</em>{`) and the npm public registry
at `}<a parentName="p" {...{
        "href": "https://registry.npmjs.org"
      }}>{`https://registry.npmjs.org`}</a>{` (the `}<em parentName="p">{`Public Registry`}</em>{`). These are
collectively called the `}<em parentName="p">{`Paid Services`}</em>{`.`}</p>
    <p>{`These npm Paid Services Terms were last updated on
March 10, 2022.
You can review prior versions at
`}<a parentName="p" {...{
        "href": "https://github.com/npm/documentation/blob/main/content/policies/private-terms.mdx"
      }}>{`https://github.com/npm/documentation/blob/main/content/policies/private-terms.mdx`}</a>{`.`}</p>
    <p>{`You may only access or use npm Paid Services by agreeing to the npm
Open Source Terms as supplemented by these npm Paid Services Terms. If
npm adds any additional functionality to npm Paid Services, you must
agree to these npm Paid Services Terms to use those new features, too.
You add these npm Paid Services Terms to your agreement with npm by
using npm Paid Services with your account (your `}<em parentName="p">{`Account`}</em>{`). These
npm Paid Services Terms then become a part of the contract between you
and npm, until you or npm disable npm Paid Services for your Account.`}</p>
    <h2>{`Payment Terms`}</h2>
    <p>{`There is no charge for use of npm Open Source. If you use Paid Services,
these payment terms apply. When enabling Paid Services, you must provide
all the payment card details requested by the Website (your `}<em parentName="p">{`Payment
Details`}</em>{`). Those details must be for a valid payment card that you have
the right to use (your `}<em parentName="p">{`Payment Card`}</em>{`). You must keep your Payment
Details up-to-date via the Website.`}</p>
    <p>{`You can disable Paid Services at any time via the Website. npm will not
refund any payment you have already made for Paid Services when you
disable Paid Services.`}</p>
    <p>{`Dollar amounts throughout this Agreement are amounts of United States
Dollars. You must pay for Paid Services in United States Dollars.`}</p>
    <p>{`Dollar amounts throughout this Agreement do not include tax. You will
pay any tax.`}</p>
    <h2>{`Use of npm Paid Services`}</h2>
    <p>{`npm will provide the private package storage and delivery features and
services described in the public documentation for npm Paid Services
at `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/"
      }}>{`https://docs.npmjs.com/`}</a>{` (the `}<em parentName="p">{`npm Paid Services
Documentation`}</em>{`). npm grants you permission to use those features and
services.`}</p>
    <p>{`npm will also provide the organization management and access control
features described in the npm Paid Services Documentation, and grants
you permission to use those features and services, for npm
"organizations" to which your Account belongs.`}</p>
    <p>{`Permission to use npm Paid Services is not exclusive to you, and you
may not transfer it to others. These npm Paid Services Terms do not
give you permission to give others rights to use npm Paid Services.
If you agree to a Payment Plan that gives you that right, you may do so
only according to that Payment Plan.`}</p>
    <h2>{`Payment for npm Paid Services`}</h2>
    <p>{`Both your permission to use npm Paid Services and npm's commitment to
provide npm Paid Services are subject to these npm Paid Services
Terms, the npm Open Source Terms, and payment for use of npm Paid
Services by your Account under a `}<em parentName="p">{`Payment Plan`}</em>{`. Payment plans include:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`the npm Solo Payment Plan at
`}<a parentName="p" {...{
            "href": "https://docs.npmjs.com/policies/solo-plan"
          }}>{`https://docs.npmjs.com/policies/solo-plan`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`or the npm Orgs Payment Plan at
`}<a parentName="p" {...{
            "href": "https://docs.npmjs.com/policies/orgs-plan"
          }}>{`https://docs.npmjs.com/policies/orgs-plan`}</a></p>
      </li>
    </ol>
    <p>{`You may not use npm Paid Services unless you or someone else has
agreed to a Payment Plan, enabled npm Paid Services for your Account
under that Payment Plan, and made payment.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      